import script from "./FileUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileUpload.vue?vue&type=script&lang=ts&setup=true"

import "./FileUpload.vue?vue&type=style&index=0&id=101c839c&lang=less"

const __exports__ = script;

export default __exports__